import { render, staticRenderFns } from "./permissionConfiguration.vue?vue&type=template&id=1fa81ade&scoped=true&"
import script from "./permissionConfiguration.vue?vue&type=script&lang=js&"
export * from "./permissionConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./permissionConfiguration.vue?vue&type=style&index=0&id=1fa81ade&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa81ade",
  null
  
)

export default component.exports